<template>
  <div>
    <v-btn
      :class="[setClass, btnClass]"
      class="btnTextForm"
      depressed
      :min-width="width"
      :height="height"
      :dark="dark"
      :disabled="disabled"
      :outlined="outlined"
      :loading="loading"
      @click="onClick()"
    >
      <span v-bind:style="{ fontSize: textSize }">
        {{ $t(text) }}
      </span>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'NormalButton',
  props: {
    text: {},
    textSize: { default: '12px' },
    height: {},
    width: { default: '100%' },
    dark: { type: Boolean, default: false },
    disabled: { default: false },
    textColor: { default: 'white' },
    color: { default: 'primary' },
    outlined: { default: false },
    btnClass: { default: '' },
    loading: { type: Boolean, default: false }
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  },
  computed: {
    setClass() {
      const color =
        this.color == 'white' ? 'white whiteColorOutline' : this.color
      return 'font-weight-bold ' + color + ' ' + this.textColor
    }
  }
}
</script>
<style lang="scss" scoped>
.btnTextForm {
  text-transform: none;
}
.btnStyle {
  max-width: 50px !important;
  padding: 0px !important;
}
.whiteColorOutline {
  border: thin solid #c8cfd7 !important;
}
</style>
